<template>
  <div>
    <div
      v-for="item in items"
      :key="item.id"
      class="order-item-container"
      :style="!enableStore && 'border-color: ##F5F5F5; background-color: #fff'"
    >
      <p class="item-name" :style="!enableStore && 'color: #F5F5F5'">{{ item.name }}</p>
      <div class="right-container">
        <p class="price-amount-text" :style="!enableStore && 'color: rgba(0, 84, 165, 0.50)'">
          {{ item.price }} {{ item.currency }}
        </p>
        <div class="quantity-buttons-container">
          <v-icon
            icon
            class="quantity-icon"
            :style="
              !getNumOfTicket(item) || !enableStore
                ? 'color: rgba(0, 84, 165, 0.50) !important'
                : 'color: #0054A5'
            "
            :disabled="!enableStore"
            @click="subOne(item)"
          >
            remove_circle
          </v-icon>
          <div
            class="quantity-text"
            :style="!enableStore && 'color: rgba(0, 84, 165, 0.50)'"
            translate="no"
          >
            {{ getNumOfTicket(item) }}
          </div>
          <v-icon
            icon
            class="quantity-icon"
            :style="enableStore ? 'color: #0054a5' : 'color: rgba(0, 84, 165, 0.50) !important'"
            :disabled="!enableStore"
            @click="addOne(item)"
          >
            add_circle
          </v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_ORGANIZATION_ORDER_ITEMS } from '@/graphql/event.graphql'
import { OrderItemType } from '@/types'

export default {
  name: 'sport-organizations-store-item-container',
  components: {},
  props: {
    organizationSlug: {
      type: String,
      default: null,
    },
    enableStore: {
      type: Boolean,
      default: false,
    },
    initialValues: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedItems: [...this.initialValues],
      items: null,
      loading: true,
      activeItemId: null,
    }
  },
  mounted() {
    if(this.selectedItems.length){
      this.activeItemId = this.selectedItems[0].id
    }
  },
  apollo: {
    getEventBySlug: {
      query: GET_ORGANIZATION_ORDER_ITEMS,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
        }
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          this.items = this.filterOrderItems(data.getOrganizationOrderItems)
        }
      },
    },
  },
  methods: {
    getNumOfTicket(item) {
      return this.selectedItems.filter(i => i.id === item.id).length
    },
    addOne(item) {
      this.selectedItems.push(item)
      this.activeItemId = item.id
      this.emitOrder()
    },
    subOne(item) {
      if (this.selectedItems.some(i => i.id === item.id)) {
        this.selectedItems.splice(
          this.selectedItems.findIndex(i => i.id === item.id),
          1,
        )
        if (!this.getNumOfTicket(item)) {
          this.activeItemId = null
        }
        this.emitOrder()
      }
    },
    emitOrder() {
      this.$emit('updateOrder', this.selectedItems)
    },
    filterOrderItems(orderItems) {
      const orderItemType =
        this.$route.name === this.routes.shared.sportSubscriptionsStore
          ? OrderItemType.PREPAID_COUPON
          : OrderItemType.MEMBERSHIP_PLAN

      return orderItems.filter(orderItem => orderItem.type === orderItemType)
    },
  },
}
</script>

<style scoped>
.order-item-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  gap: 2.5rem;
  border-radius: 0.25rem;
  border: 1px solid #0054a5;
  background: rgba(0, 130, 255, 0.15);
  margin-top: 1.5rem;
}
.right-container {
  display: flex;
  align-items: center;
  gap: 2.5rem;
  flex-shrink: 0;
}
.quantity-buttons-container {
  display: flex;
  align-items: center;
  gap: 1rem;
}
@media screen and (max-width: 480px) {
  .right-container {
    flex-direction: column;
  }
  .quantity-buttons-container {
    flex-direction: row;
  }
}
.quantity-icon {
  user-select: none;
  cursor: pointer;
}
.item-name {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
  margin-bottom: 0;
}
.price-amount-text {
  color: #333;
  text-align: right;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Source Sans Pro';
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  text-transform: uppercase;
  margin-bottom: 0;
}
.quantity-text {
  color: #0054a5;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: 'Source Sans Pro';
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  text-transform: uppercase;
}
</style>
